<!--<link rel="stylesheet" href="../../../../ujcms/src/main/webapp/templates/1/default/_files/css/index.css">-->
<template>
  <div>
    <!--轮播图-->
    <el-carousel :interval="3000" arrow="always" style="height: 445px">
      <el-carousel-item v-for="item in indexPicDOList" :key="item.cid" style="height: 445px">
        <img :src="filePathPrefix + item.pic" class="d-block w-100">
      </el-carousel-item>
    </el-carousel>

    <!--公司产品-->
    <div class="col col-lg-12">
      <div class="container mt-5 mb-5">
        <div class="introduction-index-title">
          <b>公司产品</b>
          <span>COMPANY  PRODUCTS</span>
        </div>
        <div class="row product-list">
          <div v-for="(item,index) in productList" :class="['col-3 mr-2', productAction == index ? 'product-action' : '', index != 1 ? 'mr-2' : '']"
               @mouseenter="mouseOverProduct(index)" @mouseleave="mouseOutProduct(index)" @click="navClick(item)">
            <label>{{item.title}}</label>

            <p>{{item.summary}}</p>
          </div>
        </div>
      </div>
    </div>

    <!--解决方案-->
    <div class="col col-lg-12 mt-5 solution-box">
      <div class="container mt-5 mb-5">
        <div class="introduction-index-title pt-5">
          <b>解决方案</b>
          <span>SOLUTION</span>
        </div>
        <div class="row mt-4 pb-5">
          <div class="col-3">
            <div class="solution-left">
              <span v-for="(item,index) in solutionList" :class="[solutionAction == index ? 'solution-action' : '']"
                    @click="solutionClick(item,index)">{{item.title}}</span>
            </div>
          </div>
          <div class="col-9 solution-right">
            <div class="p-4 solution-right-con">
              <label>{{solutionItem.title}}</label>
              <p>{{solutionItem.summary}}</p>
              <span @click="navClick(solutionItem, 7)">了解详情</span>
            </div>
          </div>
        </div>
        <!--<script>
          $(".solution-left>span").eq(0).addClass("solution-action");
          $('.solution-left>span').click(function (){
            $(this).addClass('solution-action').siblings().removeClass("solution-action");
          })
        </script>-->
      </div>
    </div>

    <!--成功案例-->
    <div class="col col-lg-12">
      <div class="container mt-5 mb-4">
        <div class="introduction-index-title">
          <b>成功案例</b>
          <span>SUCCESS CASES</span>
        </div>
        <div class="row mt-4 successCases-list mb-5">
          <div class="col-3 position-relative" v-for="(item,index) in successCasesList"
               @mouseenter="mouseOverSuccess(index)" @mouseleave="mouseOutSuccess(index)">
            <div class="successCases-listItme" :style="{backgroundImage: 'url(' + filePathPrefix + item.pic + ')'}">
              <!--<img :src="filePathPrefix + item.pic" class="d-block w-100 h-100" />-->
              <span>{{item.title}}</span>
            </div>
            <div class="successCases-listItme-con position-absolute p-3" :style="{display: successCasesAction == index ? 'block':'none'}">
              <label>{{item.title}}</label>
              <p>{{item.summary}}</p>
              <span @click="navClick(item)">查看详情</span>
            </div>
          </div>
        </div>
        <!--<script>
          // $('.successCases-list > div').eq(0).children('.successCases-listItme-con').css('display','block')
          $(".successCases-list>div").mouseover(function(){
            $(this).children('.successCases-listItme-con').css("display","block");
          });
          $(".successCases-list>div").mouseout(function(){
            $(this).children('.successCases-listItme-con').css("display","none");
          });
        </script>-->
      </div>
    </div>

    <!--公司简介-->
    <div class="bg-colorFBFAFF">
      <div class="introduction-index ">
        <div class="container">
          <div class="row pt-5">
            <div class="col col-lg-6 p-4">
              <div class="introduction-index-title">
                <b>公司简介</b>
                <span>COMPANY  PROFILE</span>
              </div>
              <p class="mt-2" style="background: #FBFAFF;" v-html="introduction.content"></p>
            </div>
            <div class="col col-lg-6 mt-3">
              <video controls :src="videoUrl" style="width:100%;">
                <source />
                <p>抱歉，您的浏览器不支持该视频格式。</p >
              </video>
              <!--<video controls style="width:100%;">
                <source :src="videoUrl" >
                <p>抱歉，您的浏览器不支持该视频格式。</p >
              </video>-->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--荣誉资质-->
    <div class="col col-lg-12 " style="padding: 70px 0 30px 0;">
      <div class="container mb-5">
        <div class="introduction-index-title mb-4">
          <b>荣誉资质</b>
          <span>HONORARY  QUALIFICATIONS</span>
        </div>
        <div class="row qualifications-list">
          <swiper :options="swiperOption" ref="mySwiper" class="w-100" style="height: 150px;">
            <!-- slides -->
            <swiper-slide v-for="item in qualificationsList" :key="item.cid">
              <!--<img :src="filePathPrefix + item.pic" class="d-block" />-->
              <el-image :src="filePathPrefix + item.pic" :preview-src-list="[filePathPrefix + item.pic]" class="d-block w-100" style="height: 140px;"> </el-image>
            </swiper-slide>
            <!-- Optional controls -->
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
            <!--<div class="swiper-scrollbar"   slot="scrollbar"></div>-->
          </swiper>
        </div>
      </div>
    </div>

    <!--公司新闻-->
    <div class="col col-lg-12 bg-color043B86" >
      <div class="container">
        <div class="row pt-5 pb-5">
          <div class="col col-lg-5">
            <div class="introduction-index-title">
              <b class="color-fff">公司新闻</b>
              <span class="color-fff">COMPANY  NEWS</span>
            </div>

            <el-carousel class="mt-4 position-relative" :interval="3000" indicator-position="none" arrow="hover">
              <el-carousel-item v-for="item in newsList" :key="item.cid" style="background: #333 ">
                <!--<img :src="filePathPrefix + item.pic" class="d-block w-100 h-100" />-->
                <el-image :src="filePathPrefix + item.pic" :preview-src-list="[filePathPrefix + item.pic]" class="d-block w-100"> </el-image>
                <div class="imgDiv"></div>
                <div class="carousel-caption2 d-none d-md-block">
                  <p>{{item.title}}</p>
                </div>
              </el-carousel-item>
            </el-carousel>

          </div>
          <div class="col col-lg-1"></div>
          <div class="col col-lg-6">
            <!--<div class="news-tab">
              <div>
                <span>企业内讯</span>
                <img src="" class="d-block w-100" />
              </div>
              <div>
                <span>行业资讯</span>
                <img src="" class="d-block w-100" />
              </div>
              <div>
                <span>法律法规</span>
                <img src="" class="d-block w-100" />
              </div>
              <div>
                &lt;!&ndash;                ${'${files}/img/index/border-bottom.png'}&ndash;&gt;
                <span>信息公开</span>
                <img src="" class="d-block w-100" />
              </div>
            </div>-->
            <!--<script>
              // console.log($(".news-tab>div").children('img').attr('src'))
              $(".news-tab>div").eq(0).addClass("news-tab-action");
              $(".news-tab>div").eq(0).children('img').attr("src", '${files}/img/index/border-bottom.png');
              $(".news-tab>div").click(function() {
                $(this).addClass("news-tab-action").siblings().removeClass("news-tab-action");
                $(this).children('img').attr("src", '${files}/img/index/border-bottom.png').parent().siblings().children('img').attr("src", '');
              });
            </script>-->
            <!--列表-->
            <ul class="news-list mt-4">
              <li v-for="(item,index) in newsList" :key="item.cid" @click="navClick(item)">
                <label><b>0{{index + 1}}</b>{{item.title}}</label>
                <p>{{item.summary}}</p>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>

    <!--在线客服-->
    <div class="serviceBox">
      <div class="service-imgBox" v-if="serviceAction == 1" @click="serviceActionClick(2)">
        <img src="../../assets/img/index/jia.png" class="d-block"/>
        <span>在线客服</span>
      </div>
      <div style="position: relative;">
        <div class="service-towBox" v-if="serviceAction == 2 || serviceAction == 3">
          <label>在线客服</label>
          <div>
            <div>
              <span>客服一：</span>
              <!--<div>
                <img src="../../assets/img/index/QQ.png" class="d-block"/>
                <span>QQ交谈</span>
              </div>-->
            </div>
            <span @click="serviceActionClick(3)">意见反馈</span>
          </div>
        </div>
        <div class="service-threeBox" v-if="serviceAction == 3">
          <label>意见反馈</label>
          <div>
            <el-form :model="serviceForm" :rules="rules" ref="ruleForm" label-width="0">
              <el-form-item prop="ideaType" style="margin-bottom: 16px;">
                <el-select v-model="serviceForm.ideaType" placeholder="请选择意见类型" style="width: 100%;" size="small">
                  <el-option v-for="item in options" :key="item.id"
                             :label="item.name"  :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="content" style="margin-bottom: 16px;">
                <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="serviceForm.content" size="small"/>
              </el-form-item>
              <el-form-item prop="link" style="margin-bottom: 16px;">
                <el-input v-model="serviceForm.link" placeholder="联系方式" size="small"/>
              </el-form-item>
            </el-form>
            <div style="text-align: center;margin-top: 5px;">
              <el-button size="small" style="width: 100px;" @click="serviceClear">取消</el-button>
              <el-button size="small" type="primary" style="width: 150px;" @click="serviceSubmit">提交</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Swiper from "swiper";
  import { swiper, swiperSlide } from 'vue-awesome-swiper'

  import HomeNews from './HomeNews';
  import { getIndexPicDOList, getNewsDOList, getColumnTreeList, addSaveIdea, getDictByType } from "@/api/index";
  var axios = require('axios')
  export default {
    components: {
      HomeNews,swiper,
      swiperSlide
    },
    data() {
      return {
        videoUrl: '', //http://www.ccxb315.com/files/c731eddd-e3b1-412a-893b-249b01e31839.mp4
        indexPicDOList: [],
        introduction: {},
        newsList: [],
        productAction: 0,
        productList: [],
        solutionAction: 0,
        solutionList: [],
        solutionItem: {},

        swiperOption: { //更多的参数的配置看swiper4官网介绍：http://www.swiper.com.cn/api/navigation/210.html
          autoplay: {
            delay: 1000,//1秒切换一次
          },
          loop:true,
          slidesPerView: 5,
          // slidesPerGroup : 5,
          spaceBetween: 20,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          // autoHeight: true,
          height: 140,//你的slide高度
        },
        qualificationsList: [],
        successCasesAction: 0,
        successCasesList: [],
        serviceAction: 1,
        options: [],
        serviceForm: {
          ideaType: null,
          content: null,
          link: null,
        },
        rules: {
          name: [
            { required: true, message: '请输入活动名称', trigger: 'blur' },
            { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
          ],
          ideaType: [
            { required: true, message: '请选择意见类型', trigger: 'change' }
          ],
          content: [
            { required: true, message: '请输入反馈内容', trigger: 'blur' }
          ],
          link: [
            { required: true, message: '请输入联系方式',pattern:/^((\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14})|([1][3,4,5,6,7,8,9][0-9]{9})$/, trigger: 'blur' }
          ]
        }
      }
    },
    mounted() {
      getDictByType('idea').then(response => {
        this.options = response;
      });
      getIndexPicDOList({limit:10,offset:0}).then(response => {
        this.indexPicDOList = response.rows;
      });
      getNewsDOList({limit:1,offset:0,type: 17}).then(response => {
        if(response.rows.length> 0){
          this.introduction = response.rows[0];
          this.videoUrl = this.filePathPrefix + this.introduction.pic;
          document.querySelector("video").load();
        }
      });
      getNewsDOList({limit:3,offset:0,type: 1}).then(response => {
        this.newsList = response.rows;
      });
      getNewsDOList({limit:4,offset:0,type: 18}).then(response => {
        this.productList = response.rows;
      });
      getColumnTreeList({id: 7}).then(response => {
        if(response.length> 0){
          this.solutionList = response[0].children;
          this.getsolutionItem(this.solutionList[0].id)
        }
      });
      getNewsDOList({limit: 40,offset:0,type: 20}).then(response => {
        this.qualificationsList = response.rows;
      });
      getNewsDOList({limit: 4,offset:0,type: 19}).then(response => {
        this.successCasesList = response.rows;
      });

    },
    methods: {
      navClick(row,pType){
        if(pType){
          this.$router.push({
            path:"product",
            query:{id: pType, type: row.type, cid: row.cid}
          })
        }else{
          this.$router.push({
            path:"product",
            query:{id: row.type, cid: row.cid}
          })
        }
      },
      /*意见反馈*/
      serviceActionClick(val){
        this.serviceAction = val;
      },
      serviceClear(){
        this.serviceAction = 1;
        this.serviceForm.ideaType = null;
        this.serviceForm.content = null;
        this.serviceForm.link = null;
      },
      serviceSubmit(){
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            addSaveIdea(this.serviceForm).then(response => {
              this.$message({
                message: '提交成功',
                type: 'success'
              });
              this.serviceClear();
            });
          }
        });
      },
      /*公司产品*/
      mouseOverProduct(index){
        this.productAction = index;
      },
      mouseOutProduct(index){
        this.productAction = null;
      },
      /*成功案例*/
      mouseOverSuccess(index){
        this.successCasesAction = index;
      },
      mouseOutSuccess(index){
        this.successCasesAction = null;
      },
      getsolutionItem(id){
        getNewsDOList({limit:1,offset:0,type: id}).then(response => {
          this.solutionItem = response.rows[0];
        });
      },
      solutionClick(row,index){
        this.solutionAction = index;
        this.getsolutionItem(row.id)
      }
    },
  }

</script>
<style lang="less">
  /*<!--在线客服-->*/
  .serviceBox{
    position: fixed;
    z-index: 999;
    right: 0;
    top: 100px;
    /*border: 1px solid;*/
    .service-imgBox{
      background: #555;
      padding: 10px;
      width: 45px;
      overflow: hidden;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      cursor: pointer;
      &>img{
        width: 30px;
      }
      &>span{
        display: block;
        transform: rotate(0deg);
        color: #fff;
        padding-left: 5px;
        padding-top: 10px;
      }
    }
    .service-towBox{
      width: 140px;
      border-top: 1px solid #555;
      border-left: 1px solid #555;
      border-bottom: 1px solid #555;
      &>label{
        display: block;
        background: #555;
        color: #fff;
        font-size: 14px;
        font-weight: bold;
        padding: 5px 10px;
      }
      &>div{
        background: #fff;
        margin-top: -8px;
        font-size: 13px;
        padding-bottom: 10px;
        &>div{
          display: flex;
          padding: 10px 5px;
          cursor: pointer;
          &>div{
            background-color: #96d8f7;
            display: flex;
            padding: 2px 5px;
            &>img{
              width: 18px;
              height: 18px;
              margin-right: 5px;
            }
            &>span{
              font-size: 12px;
            }
          }
        }
        &>span{
          cursor: pointer;
          background-color: #96d8f7;
          border-radius: 4px;
          display: block;
          margin: 0 15px;
          text-align: center;
          padding: 2px;
        }
      }
    }
    .service-threeBox{
      position: absolute;
      background-color: #f2f2f2;
      right: 140px;
      top: 0px;
      width: 360px;
      padding: 10px 20px 15px 20px;
      color: #333;
      font-size: 13px;
      &>label{
        display: block;
        border-bottom: 1px solid #333333;
        padding-bottom: 2px;
        font-size: 15px;
      }
      &>div{
        margin-top: 5px;
      }
    }
    /deep/  .el-form-item{
      margin-bottom: 16px !important;
    }
  }
  /*轮播图*/
  .bg-colorFBFAFF{
    background: #FBFAFF;
  }
  .swiper-container-autoheight, .swiper-container-autoheight .swiper-slide {
    height: 140px;
  }
  .swiper-slide{
    width: 100%;
    border: 5px solid #2767BE;
  }
  .swiper-pagination-bullet {
    width: 15px;
    height: 15px;
  }
  .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 8%;
  }
  .qualifications-list {
    img{
      min-width: 200px;
      width: 100%;
    }
  }

  .introduction-index{
    background-image: url("../../assets/img/index/bg1.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 100%;
  }
  .introduction-index-title > b{
    font-size: 1.3rem;
    padding-right: 10px;
  }
  .introduction-index-title > span{
    font-size: 0.9rem;
    color: #043B86;
  }

  .introduction-index{
    /*background-image: url("../img/index/bg1.jpg");*/
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 100%;
    min-height: 420px;
  }
  .introduction-index-title > b{
    font-size: 1.3rem;
    padding-right: 10px;
  }
  .introduction-index-title > span{
    font-size: 0.9rem;
    color: #043B86;
  }
  .carousel-caption2{
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 10;
    color: #fff;
    background: rgba(0,0,0,0.7);
    padding: 10px;
    font-size: 12px;
    font-family: SimHei, SimHei-Regular;
    font-weight: 400;
  }
  .carousel-caption2>p{
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; /* 超出几行省略 */
    overflow: hidden;
  }
  .news-tab{
    display: flex;
    border-bottom: 2px solid rgba(255,255,255,0.7);
    line-height: 40px;
    justify-content: space-between;
    padding: 0 10px;
  }
  .news-tab> div{
    width: 80px;
    text-align: center;
    position: relative;
    cursor: pointer;
    color: rgba(255,255,255,0.7);
  }
  .news-tab> div > img{
    /*width: 80px;*/
    position: absolute;
    bottom: -6px;
  }
  .news-tab-action{
    color: #fff !important;
  }
  .news-list{
    list-style-type: none;
    margin: 0;
    padding: 10px;
    color: #fff;
  }
  .news-list li{
    padding-bottom: 10px;
    padding-top: 5px;
  }
  .news-list label{
    display: block;
    font-size: 13px;
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow:ellipsis;
    margin: 5px;
    &>b{
      font-size: 18px;
      padding-right: 5px;
    }
  }
  .news-list p{
    display: block;
    font-size: 12px;
    overflow:hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 3;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    line-height: 20px;
    color: rgba(255,255,255,.7);
  }
  .product-list{
    margin-top: 20px;
    .col-3{
      max-width: 24%;
    }
  }
  .product-list > div{
    padding: 15px;
    height: 200px;
    overflow: hidden;
    border: 1px solid #6192e2;
  }
  .product-list > div > label{
    display: block;
    font-size: 15px;
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow:ellipsis;
    margin: 0;
  }
  .product-list > div > p{
    display: block;
    font-size: 13px;
    line-height: 20px;
    color: #404040;
    margin-top: 5px;
  }
  .product-action{
    background: #0F4B9E;
    color: #fff !important;
  }
  .product-action > p{
    color: #fff !important;
  }
  .solution-box{
    background: #FBFAFF;
  }
  .solution-left{
    background: #F5F5FD;
    padding: 0;
  }
  .solution-left>span{
    display: block;
    text-align: center;
    line-height: 45px;
    cursor: pointer;
  }
  .solution-action{
    background: #0F4B9E;
    color: #fff;
  }
  .solution-right{
    background: #F5F5FD;
    height: 180px;
    overflow: hidden;
  }
  .solution-right-con>label{
    font-size: 16px;
    font-family: SimHei, SimHei-Regular;
    font-weight: 400;
    text-align: left;
    color: #404040;
    display: block;
  }
  .solution-right-con>p{
    font-size: 13px;
    font-family: Adobe Heiti Std, Adobe Heiti Std-R;
    font-weight: normal;
    color: #404040;
    margin-top: 5px;
    overflow:hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 3;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
  .solution-right-con>span{
    font-size: 13px;
    font-family: SimHei, SimHei-Regular;
    font-weight: 400;
    color: #0F4B9E;
    display: inline-block;
    border: 1px solid #0f4b9e;
    float: right;
    width: 110px;
    text-align: center;
    line-height: 25px;
    margin-top: 15px;
    cursor: pointer;
  }
  .solution-right-con>span:hover{
    background: #0f4b9e;
    color: #fff;
  }
  .successCases-listItme{
    height: 170px;
    position: relative;
    background-size: 100%;
  }
  .successCases-listItme>img{
    position: absolute;
  }
  .successCases-listItme>span{
    margin: 0 20px;
    font-size: 15px;
    font-family: SimHei, SimHei-Regular;
    font-weight: 400;
    color: #ffffff;
    display: flex;
    justify-content:center;
    align-items:Center;
    height: 170px;
    position: absolute;
  }
  .successCases-listItme-con{
    background: #0F4B9E;
    height: 170px;
    top: 0;
    color: #fff;
    display: none;
  }
  .successCases-listItme-con>label{
    font-size: 16px;
    font-family: SimHei, SimHei-Regular;
    font-weight: 400;
    text-align: left;
    display: block;
  }
  .successCases-listItme-con>p{
    font-size: 13px;
    font-family: Adobe Heiti Std, Adobe Heiti Std-R;
    font-weight: normal;
    margin-top: 5px;
    overflow:hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 3;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
  .successCases-listItme-con>span{
    font-size: 13px;
    font-family: SimHei, SimHei-Regular;
    font-weight: 400;
    color: #fff;
    display: inline-block;
    border: 1px solid #fff;
    float: right;
    width: 90px;
    text-align: center;
    line-height: 25px;
    margin-top: 15px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/home.vue